const ASSET_SOURCE = process.env.REACT_APP_CDX_ASSET_URL;

export const AssetLinks = {
  iphone: ASSET_SOURCE + '/iphone.svg',
  logo: ASSET_SOURCE + '/hello-refi-logo.svg',
  payment: ASSET_SOURCE + '/payment.svg',
  paymentIcon: ASSET_SOURCE + '/payment-icon.svg',
  pencil: ASSET_SOURCE + '/pencil.svg',
  percentage: ASSET_SOURCE + '/percentage.svg',
  phone: ASSET_SOURCE + '/phone.svg',
  phoneCall: ASSET_SOURCE + '/phone-call.svg',
  phoneIcon: ASSET_SOURCE + '/phone-icon.svg',
  chatIcon: ASSET_SOURCE + '/chat-icon.svg',
  greenTick: ASSET_SOURCE + '/green-tick.svg',
  checkGreyWhite: ASSET_SOURCE + '/check-grey-white.svg',
  information: ASSET_SOURCE + '/information.svg',
  rightArrow: ASSET_SOURCE + '/right-arrow.svg',
  selectMarker: ASSET_SOURCE + '/select-marker.svg',
  star: ASSET_SOURCE + '/star.svg',
  tickGrey: ASSET_SOURCE + '/tick-grey.svg',
  tickwhite: ASSET_SOURCE + '/tick-white.svg',
  vehicleSide: ASSET_SOURCE + '/vehicle-side.svg',
  consultantPhoneCall: ASSET_SOURCE + '/consultant-phone-call.svg',
  carNumberPlate: ASSET_SOURCE + '/car-number-plate.svg',
  brokenCar: ASSET_SOURCE + '/broken-car.svg',
  confetti: ASSET_SOURCE + '/confetti.svg',
  car: ASSET_SOURCE + '/car.svg',
  ilendingLogo: ASSET_SOURCE + '/hello-refi-logo.svg',
  ilendingText: ASSET_SOURCE + '',
  check: ASSET_SOURCE + '/check.svg',
  error: ASSET_SOURCE + '/error.svg',
  details: ASSET_SOURCE + '/details.svg',
  employment: ASSET_SOURCE + '/employment.svg',
  info: ASSET_SOURCE + '/info.svg',
  home: ASSET_SOURCE + '/home.svg',
  ellipse: ASSET_SOURCE + '/ellipse.svg',
  dollar: ASSET_SOURCE + '/dollar.svg',
  hourglass: ASSET_SOURCE + '/hourglass.svg',
};
